<template>
  <!-- 行业资质 新增 -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :isSubmitBtn="false"
      >
      <template slot="1" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-checkbox v-decorator="formItem.props" default-checked></a-checkbox>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'industryQualificationsAdd',
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      initReqHandle: false,
      modalTitle: '新增',
      visible: false,
      formList: [
        {
          disabled: false,
          label: '类目',
          inputType: 'treeSearch',
          options: [],
          handle: '',
          isSearch: false,
          placeholder: '请选择',
          props: ['categoryIds', {
            rules: [
              { required: true, message: '请绑定类目' }
            ]
          }]
        },
        {
          label: '资质要求',
          inputType: 'select',
          options: [
          ],
          handle: '',
          placeholder: '请选择',
          props: ['certId', {
            rules: [{ required: true, message: '请选择资质要求' }]
          }]
        },
        {
          slot: '1',
          label: '必填项',
          inputType: 'input',
          props: ['isRequire', {
            rules: [{required: false, message: ''}]
          }]
        }
      ]
    };
  },
  created () {
    this.getSelection();
  },
  methods: {
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        let obj = {};
        obj.categoryIds = values.categoryIds;
        obj.certId = values.certId;
        obj.isRequire = values.isRequire === undefined ? '1' : values.isRequire ? 1 : 0;

        this.$post({
          url: '/local/qualify',
          params: {...obj}
        }).then((res) => {
          this.$message.success('操作成功');
          this.visible = false;
          this.$parent.$refs.table.getTableList();
        });
      });
    },
    getSelection () {
      this.$get({
        url: '/local/qualify/cert/selectTree',
        params: { }
      }).then((res) => {
        this.formList[1].options = res.data;
      });
      this.$get({
        url: '/local/menu/categoryTreeselect'
      }).then(res => {
        this.recursionList(res.data.menus);
        this.formList[0].options = res.data.menus;
      });
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    closeFun () {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
